import { Event } from "../../../../base/common/events.js";
import { createDecorator } from "../../../../platform/instantiation/common/registry.js";
import { URI } from "../../../../base/common/uri.js";
import { CancellationToken } from "../../../../base/common/cancellation.js";
import { VSBuffer } from "../../../../base/common/buffer.js";
import { GLTFLike } from "../../../../platform/webgl/common/gltf.js";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";

export const IProjectService = createDecorator<IProjectService>('IProjectService');

export interface ProjectDidChangeEvent {
    readonly project: IProjectService;
}

export interface ProjectOpenChangedEvent {
    readonly project: IProjectService;
    readonly type: "open" | "close";
    readonly opened?: unknown;
}

/**
 * The project provides an interface to the current hierarchy
 */
export interface IProjectService {
    readonly onDidChange: Event<ProjectDidChangeEvent>;

    add(obj: unknown, token?: CancellationToken): Promise<void>;
    remove(obj: unknown, token?: CancellationToken): Promise<void>;

    readonly onDidOpen?: Event<ProjectOpenChangedEvent>;
    readonly onDidClose?: Event<ProjectOpenChangedEvent>;

    onOpen?(data: IOpenData): Promise<void>;
    doClose?(uri: URI): Promise<void>;
    close?(): Promise<void>;

    reload?(): Promise<void>;

    save?(): Promise<void>;
}


export interface IProjectServiceWithOpenCloseCapabilities extends IProjectService {
    readonly onDidOpen: Event<ProjectOpenChangedEvent>;
    readonly onDidClose: Event<ProjectOpenChangedEvent>;

    onOpen(data: IOpenData): Promise<void>;
    doClose(uri: URI): Promise<void>;
    close(): Promise<void>;

    reload(): Promise<void>;

    save(): Promise<void>;
}

export function isProjectServiceWithOpenCloseCapabilities(service: IProjectService): service is IProjectServiceWithOpenCloseCapabilities {
    return !!(service.onOpen && service.close && service.save && service.onDidOpen && service.onDidClose);
}




export interface IOpenData {
    readonly uri: URI;
    gltf: GLTFLike & Pick<GLTF, "parser">;
    raw?: VSBuffer;
}